import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
    // wrapper: {
    //   border: `3px solid ${theme.palette.primary.main}`,
    //   borderRadius: theme.shape.borderRadiusBig,
    //   flex: 1,
    //   maxWidth: "100%",
    //   paddingTop: "10%",
    //   position: "relative",
    //   textAlign: "center",
    // },
    // title: {},
    // name: {},
    // personalNumber: {},
    // row: {},
    // signatures: {
    //   display: "flex",
    //   flexDirection: "row",
    //   justifyContent: "center",
    //   paddingLeft: VoTheme.spacing(7),
    //   paddingRight: VoTheme.spacing(7),
    //   width: "100%",
    // },
    // signature: {
    //   borderTop: `1px solid ${VoTheme.palette.common.black}`,
    //   flex: 1,
    //   marginLeft: VoTheme.spacing(1),
    //   marginRight: VoTheme.spacing(1),
    //   maxWidth: 250,
    // },
    // signaturePerson: {},
    // signatureTitle: {},
    // footer: {
    //   border: "1px solid red",
    //   bottom: 0,
    //   left: 0,
    //   position: "absolute",
    //   right: 0,
    // },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Arial",
    fontSize: 15,
    padding: VoTheme.spacing(4),
  },
  decor: {
    // display: "flex",
    // flexDirection: "column",
    height: "100%",
    paddingLeft: VoTheme.spacing(3),
    paddingRight: VoTheme.spacing(3),
    width: "100%",
  },

  header: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    // flex: "1 0 auto",
    // flex: 1,
    // height: "400px",
    // marginBottom: VoTheme.spacing(2),
    minHeight: 230,

    // border: "1px solid red",
  },

  growArea: {
    alignItems: "center",

    display: "flex",
    flexDirection: "row",
    flexGrow: 1,

    // flex: "0 0 auto",
    // flex: 1,
    marginTop: VoTheme.spacing(2),

    // border: "1px solid blue",
  },

  titleWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
    // height: "200px",
    width: "100%",

    // border: "1px solid green",
  },

  title: {
    color: VoTheme.palette.primary.main,
    fontSize: 36,
    fontWeight: 600,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  subtitle: {
    color: VoTheme.palette.primary.main,
    fontSize: 18,
    fontWeight: 600,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  logo: {
    height: "100px",
    width: "auto",
  },

  personWrapper: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
  },

  person: {
    // fontFamily: "Times-Italic",
    fontSize: 24,
    fontStyle: "italic",
    fontWeight: 500,
    marginTop: VoTheme.spacing(2),
    textAlign: "center",
  },
  personalNumber: {
    // fontFamily: "Times-Roman",
    fontSize: 12,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  text: {
    fontSize: 12,
    paddingTop: VoTheme.spacing(1),
    textAlign: "center",

    // border: "1px solid red",
  },
  textBold: {
    fontWeight: 500,
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    // height: "60px",
    marginLeft: "auto",
    marginRight: "auto",
    // marginLeft: VoTheme.spacing(-2),
    // marginRight: VoTheme.spacing(-2),
    // paddingLeft: VoTheme.spacing(5),
    // paddingRight: VoTheme.spacing(5),
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    height: "40px",
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 250,
    paddingTop: VoTheme.spacing(1),
  },
  signaturePerson: {
    fontSize: 12,
    textAlign: "center",
  },
  signatureTitle: {
    fontSize: 12,
    textAlign: "center",
  },
  publisherSection: {
    // border: "1px solid red",

    display: "flex",
    // flex: 1,
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    marginTop: VoTheme.spacing(2),
  },
  publisher: {
    fontSize: 12,
    textAlign: "center",
  },
  place: {},
  date: {
    fontSize: 12,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  footer: {
    marginTop: VoTheme.spacing(6),
  },
  uid: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  // regionSectionWrapper: {
  //   display: "flex",
  //   flex: 1,
  //   flexDirection: "column",
  //   justifyContent: "center",
  // },
  graphWrapper: {
    // alignItems: "center",
    display: "flex",
    // flex: 1,
    flexDirection: "row",
    justifyContent: "center",

    // border: "1px solid red",
  },
  graph: {
    height: "auto",
    width: 300,
  },

  stepSectionWrapper: {
    // display: "flex",
    flex: 1,
    // flexDirection: "column",
    // justifyContent: "flex-start",

    // border: "1px solid red",
  },
  stepSection: {
    alignItems: "center",

    // border: "1px solid green",

    display: "flex",

    // flex: 1,
    flexDirection: "column",
    // justifyContent: "center",
    marginBottom: VoTheme.spacing(1.5),
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 350,
    // textAlign: "center",
  },
  stepTitle: {
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
  },
  stepDescription: {
    fontSize: 10,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",

    // border: "1px solid red",
  },
  moduleSection: {
    marginTop: VoTheme.spacing(2),
  },
  moduleDescription: {
    fontSize: 10,
    maxWidth: 350,
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: VoTheme.spacing(1.5),
    textAlign: "center",
  },
  scopeSection: {
    marginBottom: VoTheme.spacing(1),
  },
});
